import { trans } from "@mongez/localization";
import { cn } from "core/shared";

type TotalTextItem = {
  type: string;
  mode: "normal" | "minus" | "plus";
  label: string;
  value: number;
  valueText: string;
};

type CartTotalsTextProps = {
  totalsText: TotalTextItem[];
};

export function CartTotalsText({ totalsText }: CartTotalsTextProps) {
  if (!totalsText || totalsText.length === 0) {
    return null;
  }

  // Separate regular items from final price
  const regularItems = totalsText.filter((item) => item.type !== "finalPrice");
  const finalPrice = totalsText.find((item) => item.type === "finalPrice");

  return (
    <div className="flex flex-col gap-3">
      {regularItems.map((item, index) => (
        <div
          key={index}
          className="flex items-center justify-between text-xs sm:text-sm md:text-base 2xl:text-lg"
        >
          <span
            className={cn({
              "text-[#737373]": item.mode === "normal",
              "text-green-600": item.mode === "minus",
              "text-red-600": item.mode === "plus",
            })}
          >
            {trans(item.label)}
          </span>
          <span
            className={cn("font-semibold", {
              "text-gray-900": item.mode === "normal",
              "text-green-600": item.mode === "minus",
              "text-red-600": item.mode === "plus",
            })}
          >
            {item.valueText}
          </span>
        </div>
      ))}

      {finalPrice && (
        <div className="my-2 flex items-center justify-between gap-2 font-bold">
          <span className="text-lg md:text-xl 2xl:text-2xl">
            {finalPrice.label}
          </span>
          <span className="text-lg sm:text-xl md:text-2xl 2xl:text-4xl">
            {finalPrice.valueText}
          </span>
        </div>
      )}
    </div>
  );
}
